'use client';
import { useTheme } from '@wrksz/themes/client';

type ThemePreference = 'system' | 'light' | 'dark';

export function useThemeMode() {
  const { theme, resolvedTheme, setTheme } = useTheme();

  const toggleMode = (newMode?: ThemePreference) => {
    if (newMode) {
      setTheme(newMode);
    } else {
      setTheme(
        theme === 'system' ? 'light' : theme === 'light' ? 'dark' : 'system',
      );
    }
  };

  const preference: ThemePreference =
    theme === 'light' || theme === 'dark' || theme === 'system'
      ? theme
      : 'system';

  return {
    isSystem: preference === 'system',
    mode: resolvedTheme,
    preference,
    toggleMode,
  };
}
